import React from 'react';
import { Fab } from '@mui/material';
import { ChatBubble } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import MainNavbar from "../components/Navbar.jsx";
import MUI from "../mui";

function Layout({children}) {
  const navigate = useNavigate();

  return (
    <MUI>
      <MainNavbar />

      {children}

      <Fab
        color="primary"
        onClick={() => navigate('../contact')}
        sx={{
          position: 'absolute',
          insetInlineEnd: '2rem',
          insetBlockEnd: '2rem',
        }}
      >
        <ChatBubble />
      </Fab>
    </MUI>
  );
}
export default Layout;